const colors = {
  primary: "#fff",
  theme: "#0e9c84", // marca (alinhado a --cp-brand)
  themeHover: "#14b89c", // --cp-brand-hover
  themeActive: "#0a7a66", // --cp-brand-active
  light1: "#F3F4F6",
  light2: "#E5E7EB",
  dark1: "#1F2937",
  dark2: "#4B5563",
  dark3: "#9CA3AF",
  red: "#e5533c", // --cp-error
};

export default colors;
